import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PharmMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">
<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>
</div>

)

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Pharma Billing</h5>

<div className="row">

<MenuCard link="/drug-view" title="OP/IP/Indent Billing" icon="fa-solid fa-capsules" color="#0d6efd"/>
<MenuCard link="/pharm-collection-all?type=salesreturn" title="Sales Return" icon="fa-solid fa-rotate-left" color="#20c997"/>
<MenuCard link="/raise-indent" title="Raise Indent" icon="fa-solid fa-file-circle-plus" color="#6f42c1"/>
<MenuCard link="/indent-drug-list" title="View Indent" icon="fa-solid fa-list" color="#fd7e14"/>
<MenuCard link="/internal-return" title="Internal Return" icon="fa-solid fa-arrow-rotate-left" color="#dc3545"/>
<MenuCard link="/add-patient" title="New Patient Registration" icon="fa-solid fa-user-plus" color="#20c997"/>

</div>

<h5 className="menu-section-title">Pharmacy Master</h5>

<div className="row">

<MenuCard link="/add-manufacturer" title="Add Manufacturer" icon="fa-solid fa-industry" color="#0d6efd"/>
<MenuCard link="/add-distributor" title="Add Distributor" icon="fa-solid fa-truck" color="#20c997"/>
<MenuCard link="/drug-list" title="Drug List" icon="fa-solid fa-pills" color="#6f42c1"/>
<MenuCard link="/drug-generic" title="Drug Generic" icon="fa-solid fa-flask" color="#fd7e14"/>
<MenuCard link="/add-new-product" title="New Drug Entry" icon="fa-solid fa-capsules" color="#dc3545"/>

</div>

<h5 className="menu-section-title">Pharmacy Reports</h5>

<div className="row">

<MenuCard link="/pharm-collection-all" title="Daily Sales Report" icon="fa-solid fa-chart-line" color="#0d6efd"/>

<MenuCard link="/sale-return-report" title="Sales Return Report" icon="fa-solid fa-rotate-left" color="#20c997"/>

<MenuCard link="/detail-sales" title="Detailed Sales Report" icon="fa-solid fa-file-lines" color="#fd7e14"/>

<MenuCard link="/sales-gst-report" title="Sales GST Report" icon="fa-solid fa-file-invoice-dollar" color="#dc3545"/>

<MenuCard link="/sales-gst-stat" title="Sales GST Statement" icon="fa-solid fa-chart-pie" color="#0dcaf0"/>

<MenuCard link="/detail-sales-gst-report" title="Detail Sales GST Report" icon="fa-solid fa-file-chart-column" color="#198754"/>

<MenuCard link="/purchase-gst-report" title="Purchase GST Report" icon="fa-solid fa-file-invoice" color="#6610f2"/>

<MenuCard link="/purchase-gst-stat" title="Purchase GST Statement" icon="fa-solid fa-chart-bar" color="#d63384"/>
<MenuCard link="/di-report" title="DI Report" icon="fa-solid fa-file-waveform" color="#20c997"/>

<MenuCard link="/schedule-report" title="Schedule Report" icon="fa-solid fa-calendar-days" color="#0d6efd"/>

<MenuCard link="/drug-flow" title="Drug Flow Report" icon="fa-solid fa-arrows-rotate" color="#dc3545"/>

<MenuCard link="/pat-drug-flow" title="Patient Flow Report" icon="fa-solid fa-users" color="#6f42c1"/>

<MenuCard link="/closing-statement" title="Closing Statement" icon="fa-solid fa-file-circle-check" color="#198754"/>

<MenuCard link="/abc-analysis" title="ABC Analysis" icon="fa-solid fa-chart-area" color="#fd7e14"/>

<MenuCard link="/daily-consolidate" title="Daily Consolidate" icon="fa-solid fa-layer-group" color="#0dcaf0"/>

<MenuCard link="/pharm-profit" title="Profit Statement" icon="fa-solid fa-indian-rupee-sign" color="#20c997"/>
<MenuCard link="/indent-expiry-list" title="Indent Expiry"   icon="fa-solid fa-calendar-check"  color="#0d6efd"/>
<MenuCard link="/expiry-list" title="Expired List"   icon="fa-solid fa-triangle-exclamation"  color="#dc3545"/>

</div>

</section>

)

}

export default PharmMenu;